import parser from "../parser";

const parseNumber = function(value) {
    return value !== void 0 ? Number(value) : null;
};

const toMs = function(year, month, _day, _hour, _minute, _second, _ms) {
    const day = _day === null ? 1 : _day;
    const hour = _hour === null ? 0 : _hour;
    const minute = _minute === null ? 0 : _minute;
    const second = _second === null ? 0 : _second;
    const ms = _ms === null ? 0 : _ms;
    return Date.UTC(year, month - 1, day, hour, minute, second, ms);
};

const timeRange = function(match) {
    const year = parseNumber(match[1]);
    let month = parseNumber(match[2]);
    let day = parseNumber(match[3]);
    let hour = parseNumber(match[4]);
    let minute = parseNumber(match[5]);
    let second = parseNumber(match[6]);
    const ms = match[7] ? Number((match[7] + "00").substring(0, 3)) : null;

    const startMs = toMs(year, month, day, hour, minute, second, ms);
    const date = new Date(startMs);
    if (
        (year !== null && date.getUTCFullYear() !== year) ||
        (month !== null && date.getUTCMonth() !== month - 1) ||
        (day !== null && date.getUTCDate() !== day) ||
        (hour !== null && date.getUTCHours() !== hour) ||
        (minute !== null && date.getUTCMinutes() !== minute) ||
        (second !== null && date.getUTCSeconds() !== second) ||
        (ms !== null && date.getUTCMilliseconds() !== ms)
    ) {
        return null;
    }

    if (day === null) {
        month += 1;
    } else if (hour === null) {
        day += 1;
    } else if (minute === null) {
        hour += 1;
    } else if (second === null) {
        minute += 1;
    } else if (ms === null) {
        second += 1;
    }
    const endMs = toMs(year, month, day, hour, minute, second, ms);

    return {
        "start": startMs,
        "end": endMs
    };
};

const rex = /^(\d{4})-(\d\d?)(?:-(\d\d?)(?:[T ](\d\d?)(?:\:(\d\d?)(?:\:(\d\d?)(?:\.(\d{1,3})\d*)?)?)?Z?)?)?/i;
const rexExact = new RegExp("^" + rex.source + "$", "i");

export default new parser.Parser({
    "match": function(string) {
        const match = string.match(rex);
        if (match === null) {
            return null;
        }

        const range = timeRange(match);
        if (range === null) {
            return null;
        }
        return {
            "match": range,
            "tail": string.slice(match[0].length)
        };
    },

    "parse": function(string) {
        const match = string.match(rexExact);
        if (match === null) {
            return null;
        }
        return timeRange(match);
    },

    "format": function(milliseconds) {
        const value = Math.floor(milliseconds);
        const date = new Date(value);

        let cutoff = 19;
        if (value % 10 !== 0) {
            cutoff = 23;
        } else if (value % 100 !== 0) {
            cutoff = 22;
        } else if (value % 1000 !== 0) {
            cutoff = 21;
        }
        return date.toISOString().replace("T", " ").substring(0, cutoff) + "Z";
    }
});



// WEBPACK FOOTER //
// ./src/abusesa-js/formats/_timerange.js